import { AstNodeCategory, AstNodeType } from './node';
export class ReturnStatement {
    constructor(token, returnValue) {
        this.token = token;
        this.returnValue = returnValue;
        this.nodeType = AstNodeType.ReturnStatement;
        this.nodeCategory = AstNodeCategory.Statement;
    }
    get ReturnValue() {
        return this.returnValue;
    }
    set ReturnValue(val) {
        this.returnValue = val;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        let exprStr = '';
        if (this.returnValue) {
            exprStr = this.returnValue.toString();
        }
        return `${this.token.literal} ${exprStr};`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmV0dXJuU3RhdGVtZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9hc3QvUmV0dXJuU3RhdGVtZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sRUFBRSxlQUFlLEVBQUUsV0FBVyxFQUF5QixNQUFNLFFBQVEsQ0FBQztBQUU3RSxNQUFNLE9BQU8sZUFBZTtJQUN4QixZQUFvQixLQUFZLEVBQVUsV0FBd0I7UUFBOUMsVUFBSyxHQUFMLEtBQUssQ0FBTztRQUFVLGdCQUFXLEdBQVgsV0FBVyxDQUFhO1FBRWxFLGFBQVEsR0FBZ0IsV0FBVyxDQUFDLGVBQWUsQ0FBQztRQUNwRCxpQkFBWSxHQUFvQixlQUFlLENBQUMsU0FBUyxDQUFDO0lBSFcsQ0FBQztJQUt0RSxJQUFJLFdBQVc7UUFDWCxPQUFPLElBQUksQ0FBQyxXQUFXLENBQUM7SUFDNUIsQ0FBQztJQUVELElBQUksV0FBVyxDQUFDLEdBQUc7UUFDZixJQUFJLENBQUMsV0FBVyxHQUFHLEdBQUcsQ0FBQztJQUMzQixDQUFDO0lBRUQsWUFBWTtRQUNSLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUM7SUFDOUIsQ0FBQztJQUVELFFBQVE7UUFDSixJQUFJLE9BQU8sR0FBRyxFQUFFLENBQUM7UUFDakIsSUFBSSxJQUFJLENBQUMsV0FBVyxFQUFFO1lBQ2xCLE9BQU8sR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFDLFFBQVEsRUFBRSxDQUFDO1NBQ3pDO1FBQ0QsT0FBTyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxJQUFJLE9BQU8sR0FBRyxDQUFDO0lBQy9DLENBQUM7Q0FDSiJ9